import { ShortCodeService } from '@ht/lib-plural-vue';

export default function useDynamicUrl(urlTemplate) {
  return new ShortCodeService(urlTemplate).matchAttributes(false).getValue();
}
